import * as React from "react";
import { Layout } from "../components/Layout";
import { PageTitle } from "../components/common/PageTitle";
import { FormattedMessage } from "../components/utils/FormattedMessage";
import { Intro } from "../components/contacts/Intro";
import { BlockSpace } from "../components/common/BlockSpace";
import { Overview } from "../components/contacts/Overview";
import { Contacts } from "../components/contacts/Contacts";
import { OpeningTimeAndMap } from "../components/contacts/OpeningTimeAndMap";
import { HeadProps } from "gatsby";
import { DefaultHeaders } from "../components/SEO/DefaultHeaders";
import { DefaultLanguageRedirect } from "../components/common/redirect/DefaultLanguageRedirect";

export default function Index() {
  return (
    <DefaultLanguageRedirect>
      <Layout>
        <PageTitle>
          <FormattedMessage id="contacts.page_title" />
        </PageTitle>
        <BlockSpace />
        <Intro />
        <BlockSpace />
        <Overview />
        <BlockSpace />
        <Contacts />
        <BlockSpace />
        <OpeningTimeAndMap />
        <BlockSpace />
      </Layout>
    </DefaultLanguageRedirect>
  );
}

export const Head = ({
  pageContext: { intl },
  location: { pathname },
}: HeadProps<PageDataProps, PageContextType>) => {
  return (
    <DefaultHeaders
      intl={intl}
      description={intl.messages["contacts.meta.description"]}
      title={intl.messages["contacts.meta.title"]}
      keywords={intl.messages["contacts.meta.keywords"]}
      pathname={pathname}
    />
  );
};
